declare global {
  interface Window {
    initHhitMap: (referenceID: string, mapOptions: google.maps.MapOptions) => void;
  }
}

import { Loader } from '@googlemaps/js-api-loader';
import initMap from './google-map-init';

function initHhitMap(referenceID: string, mapOptions: google.maps.MapOptions) {
  const loader = new Loader({
    apiKey: 'AIzaSyAxQOSQduUU9wOxVIQcFRRXCYGfvcstVOQ',
    version: 'weekly',
  });

  const refElement = document.getElementById(referenceID);

  // Promise
  loader
    .load()
    .then((google) => {
      initMap(refElement, mapOptions);
    })
    .catch((e) => {
      console.error(e);
    });
}

const mapBlocks = document.querySelectorAll('.hhit-google-map') as NodeListOf<HTMLElement>;

mapBlocks.forEach((mapBlock) => {
  const { refId, mapOptions } = mapBlock.dataset;
  const parsedOptions = JSON.parse(mapOptions) as google.maps.MapOptions;

  initHhitMap(refId, parsedOptions);
});
